// KPI tile grid for the Skip report pages — mirrors the inline KPI grid in
// the Collections MetricsPage (coloured left-edge accent per tone).

import styles from '../skipReports.module.css';

export type KpiTone = 'blue' | 'green' | 'amber' | 'red' | 'purple' | 'teal';

export interface KpiTile {
  label: string;
  value: string;
  tone: KpiTone;
}

export function KpiGrid({ tiles }: { tiles: KpiTile[] }): JSX.Element | null {
  if (tiles.length === 0) return null;
  return (
    <ul className={styles.kpiGrid} aria-label="Key metrics">
      {tiles.map((k) => (
        <li key={k.label} className={`${styles.kpi} ${styles[`tone_${k.tone}`]}`}>
          <span className={styles.kpiLabel}>{k.label}</span>
          <span className={styles.kpiValue}>{k.value}</span>
        </li>
      ))}
    </ul>
  );
}
